<template>
    <div>
        <b-tab :active="active">
            <template v-slot:title>
                {{title}} <b-badge md>{{orders.length}}</b-badge>
            </template>

            <p v-show="orders.length <= 0">
                <b>You have no orders here</b>
            </p>

            <div class="col">
                <b-table
                    hover
                    striped
                    sticky-header="88vh"
                    bordered
                    outlined
                    small
                    fixed
                    no-border-collapse
                    head-variant="dark"
                    :items="orders" 
                    :fields="fields"
                    v-show="orders.length > 0"
                >
                    <!-- A virtual column -->
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1 }}
                    </template>

                    <!-- A virtual column -->
                    <template v-slot:cell(id)="data">
                        <b-button @click="showOrder" :data-id="data.item.id">View</b-button>
                    </template>

                </b-table>
            </div>
        </b-tab>
    </div>
</template>

<script>

export default {
    name: 'OrdersTable',
    props: [
        'orders',
        'title',
        'active',
    ],
    data() {
      return {
        fields: [
            'index',
            {
                key: 'status',
                label: 'Status',
                sortable: true,
                formatter: (value, key, item) => {

                    var title = ''

                    if(!item.processed) {
                        title += `Awaiting processing`
                    } else if(item.processed && !item.fulfilled) {
                        title += `Ready for collection`
                    } else if(item.processed && item.fulfilled) {
                        title += `Completed`
                    }

                    return title
                }
            },
            {
                key: 'total',
                label: 'Total',
                sortable: true,
                formatter: (value) => {
                    return '$' + value
                }
            },
            {
                key: 'created_at',
                label: 'Placed On',
                sortable: true,
                formatter: 'formatDate'
            },
            {
                key: 'id',
                label: '',
            },
        ]
      }
    },
    methods: {
        subsribeToEvents: function () {
            this.$store.dispatch('SUBSCRIBE_TO_EVENTS')
        },
        updateFulfilled: function (event) {
            this.$store.dispatch('UPDATE_ORDER_PROCESSED_STATUS', event)
        },
        toggleProducts: function (e) {
            if(e.target.nextSibling.style.display === 'none') {
                e.target.innerHTML = 'Hide Items'
                e.target.nextSibling.style.display = 'block'    
            }else{
                e.target.innerHTML = 'Show Items'
                e.target.nextSibling.style.display = 'none'    
            }
        },
        formatDate: function (date) {
            date = new Date(date)
            var months = [
                "January", "February", "March", "April", "May", "June", "July",
                "August", "September", "October", "November", "December"
            ];

            return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
        },
        showOrder: function (e) {
            this.$store.dispatch(
                'SAVE_CURRENT_ORDER', 
                this.orders.find((item) => item.id == Number(e.target.dataset.id))
            )
            this.$bvModal.show('single-order')
        },
    }
}
</script>